import React from "react";
import { Grid } from "@mui/material";

import Input from "../../ReadOnlyInput";
import EnderecoSection from "../../sections/EnderecoSection";
import InformacoesPessoaisSection from "../../sections/InformacoesPessoaisEmpresariaisSection";
import InformacoesFinanceirasSection from "../../sections/InformacoesFinanceirasSection";
import InformacoesProfissionaisSection from "../../sections/InformacoesProfissionaisSection";
import PessoaPoliticamenteExpostaSection from "../../sections/PessoaPoliticamenteExpostaSection";

import AccordionItem from "../../../../../components/AccordionItem";
import AccordionWrapper from "../../../../../components/AccordionWrapper";

import { formatCPF, formatUpperCase } from "../../../../../utils/formats";

import { Card } from "./styled";
import { ComponentWrapper, CardWrapper, Label, Text } from "../../styles";
import { map, size } from "lodash";

const GarantiaAvalistasComponent = (props) => {
  const {
    proposalWarrantGuarantorsOtherCompanies,
    proposalWarrantGuarantorsCustomerAccounts,
    proposalWarrantyGuarantors,
    proposalWarrantyGuarantorsLoading,
  } = props;

  const renderItem = (completeRegistration, index) => {
    return (
      <CardWrapper>
        <Label>
          {size(proposalWarrantyGuarantors) < 2
            ? "Avalista"
            : `Avalista ${index + 1}`}
        </Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item md={9}>
              <Input
                loading={proposalWarrantyGuarantorsLoading}
                disabled
                label="Nome"
                value={formatUpperCase(completeRegistration.nomeCliente)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyGuarantorsLoading}
                disabled
                label="CPF"
                value={formatCPF(completeRegistration.cpfCnpj)}
              />
            </Grid>
          </Grid>
          <AccordionWrapper>
            <AccordionItem title="Informações pessoais">
              <Card>
                <InformacoesPessoaisSection
                  tipoPessoa="F"
                  proposalCompleteRegistrationLoading={
                    proposalWarrantyGuarantorsLoading
                  }
                  completeRegistrationLoading={
                    proposalWarrantyGuarantorsLoading
                  }
                  numeroCpf={completeRegistration.cpfCnpj}
                  numeroCnpj={completeRegistration.cpfCnpj}
                  nomeCliente={completeRegistration.nomeCliente}
                  dataNascimentoCliente={
                    completeRegistration.dataNascimentoCliente
                  }
                  idadeCliente={completeRegistration.idadeCliente}
                  descricaoSexo={completeRegistration.descricaoSexo}
                  nacionalidade={completeRegistration.nacionalidade}
                  naturalidade={completeRegistration.naturalidade}
                  ufNaturalidade={completeRegistration.ufNaturalidade}
                  dataCadastro={completeRegistration.dataCadastro}
                  dataValidadeCadastro={
                    completeRegistration.dataValidadeCadastro
                  }
                  descricaoTipoDocumento={
                    completeRegistration.descricaoTipoDocumento
                  }
                  numeroDocumento={completeRegistration.numeroDocumento}
                  dataExpedicaoDocumento={
                    completeRegistration.dataExpedicaoDocumento
                  }
                  siglaOrgaoEmissor={completeRegistration.siglaOrgaoEmissor}
                  nomePai={completeRegistration.nomePai}
                  nomeMae={completeRegistration.nomeMae}
                  dddTelefone={completeRegistration.dddTelefone}
                  telefone={completeRegistration.telefone}
                  dddCelular={completeRegistration.dddCelular}
                  celular={completeRegistration.celular}
                  email={completeRegistration.email}
                  descricaoGrauInstrucao={
                    completeRegistration.descricaoGrauInstrucao
                  }
                  numeroDependentes={completeRegistration.numeroDependentes}
                  isAnalfabeto={completeRegistration.isAnalfabeto}
                  isEmancipado={completeRegistration.isEmancipado}
                  descricaoEstadoCivil={
                    completeRegistration.descricaoEstadoCivil
                  }
                  isUniaoEstavel={completeRegistration.isUniaoEstavel}
                />
              </Card>
            </AccordionItem>
            <AccordionItem title="Endereço">
              <EnderecoSection
                completeRegistrationLoading={proposalWarrantyGuarantorsLoading}
                cep={completeRegistration.cep}
                endereco={completeRegistration.endereco}
                enderecoNumero={completeRegistration.enderecoNumero}
                complemento={completeRegistration.complemento}
                bairro={completeRegistration.bairro}
                nomeCidade={completeRegistration.nomeCidade}
                uf={completeRegistration.uf}
                pais={completeRegistration.pais}
              />
            </AccordionItem>
            <AccordionItem title="Informações profissionais">
              <InformacoesProfissionaisSection
                completeRegistrationLoading={proposalWarrantyGuarantorsLoading}
                participacoesOutrasEmpresasLoading={
                  proposalWarrantyGuarantorsLoading
                }
                trabalhoNomeEmpresa={completeRegistration.trabalhoNomeEmpresa}
                trabalhoCnpjEmpresa={completeRegistration.trabalhoCnpjEmpresa}
                trabalhoEnderecoEmpresa={
                  completeRegistration.trabalhoEnderecoEmpresa
                }
                trabalhoCepEmpresa={completeRegistration.trabalhoCepEmpresa}
                trabalhoNumeroEmpresa={
                  completeRegistration.trabalhoNumeroEmpresa
                }
                trabalhoComplementoEmpresa={
                  completeRegistration.trabalhoComplementoEmpresa
                }
                trabalhoBairroEmpresa={
                  completeRegistration.trabalhoBairroEmpresa
                }
                trabalhoCidadeEmpresa={
                  completeRegistration.trabalhoCidadeEmpresa
                }
                trabalhoUfEmpresa={completeRegistration.trabalhoUfEmpresa}
                trabalhoDddTelefoneEmpresa={
                  completeRegistration.trabalhoDddTelefoneEmpresa
                }
                trabalhoTelefoneEmpresa={
                  completeRegistration.trabalhoTelefoneEmpresa
                }
                rendaBruta={completeRegistration.rendaBruta}
                dataAdmissao={completeRegistration.dataAdmissao}
                descricaoProfissao={completeRegistration.descricaoProfissao}
                descricaoCargo={completeRegistration.descricaoCargo}
                participacoesOutrasEmpresas={
                  proposalWarrantGuarantorsOtherCompanies[index]
                }
              />
            </AccordionItem>
            <AccordionItem title="PEP">
              <PessoaPoliticamenteExpostaSection
                proposalCompleteRegistrationLoading={
                  proposalWarrantyGuarantorsLoading
                }
                isPoliticamenteExposto={
                  completeRegistration.isPoliticamenteExposto
                }
                isParentePoliticamenteExposto={
                  completeRegistration.isParentePoliticamenteExposto
                }
              />
            </AccordionItem>
            <AccordionItem title="Informações financeiras">
              <InformacoesFinanceirasSection
                clienteContasLoading={proposalWarrantyGuarantorsLoading}
                clienteContas={proposalWarrantGuarantorsCustomerAccounts[index]}
              />
            </AccordionItem>
          </AccordionWrapper>
        </Card>
      </CardWrapper>
    );
  };

  const renderItems = () => {
    return proposalWarrantyGuarantorsLoading ? (
      <CardWrapper>
        <Label>{"Avalista"}</Label>
        <Grid item xs={12}>
          <Input loading={proposalWarrantyGuarantorsLoading}></Input>
        </Grid>
      </CardWrapper>
    ) : size(proposalWarrantyGuarantors) === 0 ? (
      <CardWrapper>
        <Label>{"Avalista"}</Label>
        <Grid item xs={12}>
          <Text>SEM DADOS.</Text>
        </Grid>
      </CardWrapper>
    ) : (
      <>
        {map(proposalWarrantyGuarantors, (it, index) => {
          return renderItem(it, index);
        })}
      </>
    );
  };

  return <ComponentWrapper>{renderItems()}</ComponentWrapper>;
};

export default GarantiaAvalistasComponent;
